import React from "react";
import { Header } from "../../components/layout/Header";
import { Card } from "../../components/common/Card";
import { BarChart2, TrendingUp, Award } from "lucide-react";

export default function StatsPage() {
  return (
    <>
      <Header title='Stats' />
      <div className='px-4 py-4 space-y-4'>
        <Card accent='#006d24'>
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 rounded-xl bg-green-50 flex items-center justify-center'>
              <BarChart2 size={22} className='text-green-700' />
            </div>
            <div>
              <p className='font-bold text-primary-800'>AI Stat Cards</p>
              <p className='text-xs text-gray-400'>Coming soon in MVP 1.5</p>
            </div>
          </div>
        </Card>

        <Card accent='#006d24'>
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 rounded-xl bg-green-50 flex items-center justify-center'>
              <TrendingUp size={22} className='text-green-700' />
            </div>
            <div>
              <p className='font-bold text-primary-800'>Round History</p>
              <p className='text-xs text-gray-400'>
                Available after rounds are completed
              </p>
            </div>
          </div>
        </Card>

        <Card accent='#006d24'>
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 rounded-xl bg-green-50 flex items-center justify-center'>
              <Award size={22} className='text-green-700' />
            </div>
            <div>
              <p className='font-bold text-primary-800'>Performance Insights</p>
              <p className='text-xs text-gray-400'>
                AI-driven insights coming soon
              </p>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
